import { authRoles } from "../../../auth/authRoles";
import Beranda from "./Beranda";

const berandaRoute = [
  {
    path: "/beranda",
    exact: true,
    component: Beranda,
    auth: authRoles.all,
  },
];

export default berandaRoute;
